import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

var SvgAlertTriangle = function SvgAlertTriangle(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    role: "img"
  }, props), {}, {
    children: [_jsx("path", {
      fill: props.color || '#222222',
      fillRule: "evenodd",
      d: "M6.284 1.97a2 2 0 0 1 3.323-.164l.11.164 5.985 10.003a2 2 0 0 1-1.536 3.019l-.18.008H2.014a2 2 0 0 1-1.802-2.868l.086-.159L6.284 1.97Zm2.23.17a1 1 0 0 0-1.306.247l-.066.097-5.986 10.002a1 1 0 0 0 .741 1.507l.117.007h11.972a1 1 0 0 0 .912-1.41l-.054-.104L8.858 2.484a1 1 0 0 0-.344-.345ZM8 4.5a.75.75 0 0 1 .743.648l.007.102v4.5a.75.75 0 0 1-1.493.102L7.25 9.75v-4.5A.75.75 0 0 1 8 4.5Z",
      clipRule: "evenodd"
    }), _jsx("path", {
      fill: props.color || '#222222',
      d: "M8 13.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    })]
  }));
};

export default SvgAlertTriangle;